<!-- Görünüm menüsü tetikleyicisi (Kompakt anahtarının sağında, aynı kapsülde) -->
<button
  #tetik
  type="button"
  class="gorunum-tetik"
  [class.acik]="acik"
  title="Görünüm ayarları"
  aria-label="Görünüm ayarları"
  aria-haspopup="dialog"
  [attr.aria-expanded]="acik"
  (click)="ac($event)"
>
  <i class="fa-solid fa-chevron-down"></i>
</button>

<!-- Pencere: ngAfterViewInit'te body'ye taşınır -->
<div #katman class="gorunum-katman">
  <div
    *ngIf="acik"
    class="gorunum-pencere"
    role="dialog"
    aria-label="Görünüm"
    [style.top.px]="konum.top"
    [style.right.px]="konum.right"
  >
    <div class="gorunum-baslik">
      <i class="fa-solid fa-sliders"></i>
      <span>Görünüm</span>
    </div>

    <!-- Kompakt düzen -->
    <button type="button" class="gorunum-anahtar-satir" role="switch" [attr.aria-checked]="!!(duzen.kompakt$ | async)" (click)="duzen.kompaktDegistir()">
      <span class="gorunum-metin">
        <span class="gorunum-ad">Kompakt düzen</span>
        <span class="gorunum-aciklama">Menü daralır, açık sekmeler sabit panelde</span>
      </span>
      <span class="gorunum-ray" [class.on]="duzen.kompakt$ | async"><span class="gorunum-top"></span></span>
    </button>

    <div class="gorunum-ayrac"></div>

    <!-- Sol menü -->
    <div class="gorunum-satir">
      <span class="gorunum-ad">Sol menü</span>
      <span class="gorunum-secim" role="radiogroup" aria-label="Sol menü">
        <button type="button" role="radio" [class.secili]="duzen.menuAcik$ | async" [attr.aria-checked]="!!(duzen.menuAcik$ | async)" (click)="duzen.menuyuAc(true)">Açık</button>
        <button type="button" role="radio" [class.secili]="!(duzen.menuAcik$ | async)" [attr.aria-checked]="!(duzen.menuAcik$ | async)" (click)="duzen.menuyuAc(false)">Daraltılmış</button>
      </span>
    </div>

    <!-- Açık sekmeler -->
    <div class="gorunum-satir">
      <span class="gorunum-ad">Açık sekmeler</span>
      <span class="gorunum-secim" role="radiogroup" aria-label="Açık sekmeler">
        <button type="button" role="radio" [class.secili]="!(duzen.panelSabit$ | async)" [attr.aria-checked]="!(duzen.panelSabit$ | async)" (click)="duzen.paneliSabitle(false)">Üst şerit</button>
        <button type="button" role="radio" [class.secili]="duzen.panelSabit$ | async" [attr.aria-checked]="!!(duzen.panelSabit$ | async)" (click)="duzen.paneliSabitle(true)">Sabit panel</button>
      </span>
    </div>

    <!-- Panel yeri -->
    <div class="gorunum-satir">
      <span class="gorunum-ad">Panel yeri</span>
      <span class="gorunum-secim" role="radiogroup" aria-label="Panel yeri">
        <button type="button" role="radio" [class.secili]="duzen.panelSol$ | async" [attr.aria-checked]="!!(duzen.panelSol$ | async)" (click)="duzen.paneliSolaAl(true)">
          <i class="fa-solid fa-arrow-left-long"></i> Sol
        </button>
        <button type="button" role="radio" [class.secili]="!(duzen.panelSol$ | async)" [attr.aria-checked]="!(duzen.panelSol$ | async)" (click)="duzen.paneliSolaAl(false)">
          Sağ <i class="fa-solid fa-arrow-right-long"></i>
        </button>
      </span>
    </div>

    <!-- Panel genişliği (sabit panelde etkili) -->
    <div class="gorunum-satir" [class.soluk]="!(duzen.panelSabit$ | async)">
      <span class="gorunum-ad">
        Panel genişliği
        <span *ngIf="ozelGenislik(duzen.panelGenislik$ | async)" class="gorunum-ozel">özel {{ duzen.panelGenislik$ | async }} px</span>
      </span>
      <span class="gorunum-secim" role="radiogroup" aria-label="Panel genişliği">
        <button
          *ngFor="let g of genislikler"
          type="button"
          role="radio"
          [class.secili]="(duzen.panelGenislik$ | async) === g.deger"
          [attr.aria-checked]="(duzen.panelGenislik$ | async) === g.deger"
          [title]="g.deger + ' px'"
          (click)="duzen.panelGenisligi(g.deger)"
        >{{ g.ad }}</button>
      </span>
    </div>
    <div class="gorunum-ipucu" [class.soluk]="!(duzen.panelSabit$ | async)">Panelin kenarından sürükleyerek de ayarlanır.</div>

    <div class="gorunum-ayrac"></div>

    <button type="button" class="gorunum-varsayilan" (click)="varsayilan()">
      <i class="fa-solid fa-rotate-left"></i> Varsayılana dön
    </button>
  </div>
</div>
